import { createContext } from 'react';

import type { Theme } from '../types/theme';

export interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  setTheme: () => { },
});

ThemeContext.displayName = 'ThemeContext';

export default ThemeContext;
